const dezenas = [
    'dez',
    'onze',
    'doze',
    'treze',
    'quatorze',
    'quinze',
    'dezesseis',
    'dezessete',
    'dezoito',
    'dezenove'
];

export default dezenas;



// WEBPACK FOOTER //
// ./src/app/shared/helpers/numberToWord/lib/nomesExtenso/dezenas.ts